import MobileLayout from '../../layouts/MobileLayout';
import DoneContent from '../shared/DoneContent';

type Props = {
  onComplete: () => Promise<void>;
  continueInApp: boolean;
  deliveryMode: 'redirect' | 'webhook';
};

export default function MobileDonePage(props: Props) {
  return (
    <MobileLayout>
      <DoneContent {...props} />
    </MobileLayout>
  );
}
